module.exports = __webpack_public_path__ + "img/840-f9ba8a.png";